import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { createUser, State } from "./actions/register";
import { use, useActionState, useEffect, useRef } from "react";
import Label from "../../components/label";
import Input from "../../components/input";
import {
  AtSymbolIcon,
  ExclamationCircleIcon,
  KeyIcon,
  PhoneIcon,
  UserCircleIcon,
} from "@heroicons/react/24/outline";
import FormError from "../../components/form-error";
import { Button } from "../../components/button";
import Fonts from "../../core/fonts";
import { useAuth } from "../../context/AuthContext";
import Select from "../../components/select";
const contries = require("../../utils/countries.json");

export default function RegisterPage() {
  const auth = useAuth();
  const navigate = useNavigate();  
  const [searchParams] = useSearchParams();
  const callbackUrl = searchParams.get("callbackUrl") || "/";
  const countrySelectRef = useRef<HTMLDivElement>(null);
  const initialState: State = {
    errors: {},
    message: null,
    defaultValues: {
      name: "",
      phone: "",
      country: "",
    },
  };
  const [state, formAction,isPending] = useActionState(createUser, initialState);
  useEffect(() => {
    if (state?.success) {
      if(state && state.defaultValues)
        navigate("/auth/verify-phone?phone="+state.defaultValues.phone+"&verificationId="+state.data?.verificationId);
    }
  }, [state, callbackUrl]);
  return (
    <div className="flex items-center justify-center flex-1">
      <form className="space-y-3 w-full max-w-md " action={formAction}>
        <div className="flex-1 rounded-lg bg-gray-50  px-6 py-4 pt-8 ">
          <h1 className={`${Fonts.lusitanaRegular} mb-3 text-2xl`}>Register</h1>
          <div className="w-full  text-left">
            <div className="">
              <Label htmlFor="name">User Name</Label>
              <Input
                id="name"
                name="name"
                defaultValue={state?.defaultValues?.name || ""}
                Icon={UserCircleIcon}
                placeholder="Enter your name"
                aria-describedby="name-error"
                required
              ></Input>
              <FormError
                id="name-error"
                message={state?.errors?.name}
              ></FormError>
            </div>
            <div className="mt-4">
              <Label                
                htmlFor="country"
                id="country-label"
                onClick={() => {
                  // Focus the select element when label is clicked
                  if (countrySelectRef.current) {
                    const focusableElement = countrySelectRef.current.querySelector('[tabindex="0"]') as HTMLElement;
                    if (focusableElement) {
                      focusableElement.focus();
                    }
                  }
                }}
              >
                Country
              </Label>
              <div ref={countrySelectRef}>
                <Select
                  id="country"
                  name="country"
                  aria-describedby="country-error"
                  items={contries.map((c: any) => {
                    return {
                      id: c.phone_code,
                      name: c.name + " (" + c.phone_code + ")",
                      image: c.flag_url,
                    };
                  })}
                  defaultValue={"+44"}
                  required
                  showImages={true}
                ></Select>
              </div>
            </div>
            <div className="mt-4">
              <Label htmlFor="phone">Phone</Label>
              <Input
                id="phone"
                name="phone"
                type="number"                
                Icon={PhoneIcon}
                defaultValue={state?.defaultValues?.phone || ""}
                placeholder="Enter your phone"
                aria-describedby="phone-error"
                required
              ></Input>
              <FormError
                id="phone-error"
                message={state?.errors?.phone}
              ></FormError>
            </div>
          
          </div>
          <div className="flex h-8 items-end space-x-1">
            {state?.message && (
              <>
                <ExclamationCircleIcon className="h-5 w-5 text-red-500" />
                <p className="text-sm text-red-500">{state.message.description}</p>
              </>
            )}
          </div>
          <div className="flex items-center justify-around mt-4">
            <Link to={"/auth/login"} className="flex items-center" >
              <Button type="reset" disabled={isPending} >Cancel</Button>
            </Link>
            <Button loading={isPending}>Create</Button>
          </div>
          <input type="hidden" name="redirectTo" value={callbackUrl} />
        </div>
      </form>
    </div>
  );
}
